// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: true,
  stripe_key: 'pk_live_51I3drEC39cum781eMq5b4tCSumPA4AWHbsofgVVwGDLx8id2hwQh0PKghPHEbKQzIvJvafc7w7bBNZfXqx42JEdR00rLXovtm6'
};

export const environment_test = {
  production: false,
  stripe_key: 'pk_test_51I3drEC39cum781ecGWj0B0P4oIitKpRl5buHtjpajuMb4jx7O95Z6zFHpnbedZL2MrIIElq8rC5n1icbQGwAh0200oogjPEnR'
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
